<p>dp-stats works!</p>
